import Skeleton from '@components/skeletons/Skeleton';
import { Col, FlexibleDiv, Row } from '@components/formStyles';
import { useDevice } from '@contexts/device';

import {
  AmenitySkeleton,
  AmenitySkeletonContent,
  ImagesSkeleton,
  OpportunitySkeleton,
  OpportunitySkeletonContent,
  SkeletonContentWrapper,
  SkeletonWrapper,
  SummarySkeleton,
} from './style';

const TrinityImageViewSkeleton = () => {
  const { isDesktop, isTablet } = useDevice();

  return (
    <ImagesSkeleton>
      <Skeleton height={isDesktop || isTablet ? 402 : 158} borderRadius={8} />

      {isDesktop || isTablet ? (
        <FlexibleDiv>
          <FlexibleDiv bottom={20}>
            <Skeleton height={192} borderRadius={8} />
          </FlexibleDiv>
          <Skeleton height={192} borderRadius={8} />
        </FlexibleDiv>
      ) : null}
    </ImagesSkeleton>
  );
};

const DetailSummarySkeleton = () => {
  const { isDesktop, isTablet, isMobile } = useDevice();

  return (
    <SummarySkeleton>
      <Row>
        <Col>
          <FlexibleDiv right={isDesktop || isTablet ? 108 : 0}>
            <Row>
              <Col>
                <FlexibleDiv
                  bottom={isDesktop || isTablet ? 8 : 25}
                  right={isDesktop || isTablet ? 0 : 30}
                >
                  <Skeleton
                    width={isDesktop || isTablet ? 226 : 236}
                    height={24}
                    borderRadius={8}
                  />
                </FlexibleDiv>
              </Col>
              {isMobile ? (
                <Skeleton width={24} height={25} borderRadius={8} />
              ) : null}
            </Row>
            {isMobile ? (
              <FlexibleDiv bottom={25}>
                <Skeleton
                  width={isMobile ? 278 : 470}
                  height={140}
                  borderRadius={8}
                />
              </FlexibleDiv>
            ) : null}

            {isDesktop || isTablet ? (
              <FlexibleDiv bottom={52}>
                <Skeleton width={105} height={18} borderRadius={8} />
              </FlexibleDiv>
            ) : null}

            <FlexibleDiv bottom={isDesktop || isTablet ? 35 : 50}>
              {isDesktop || isTablet ? (
                <Row>
                  {[1, 2, 3].map((item) => (
                    <FlexibleDiv key={item} right={9}>
                      <Skeleton width={134} height={40} borderRadius={8} />
                    </FlexibleDiv>
                  ))}
                </Row>
              ) : (
                <Row>
                  <Skeleton width={278} height={44} borderRadius={8} />
                </Row>
              )}
            </FlexibleDiv>

            <FlexibleDiv bottom={8}>
              <Skeleton
                width={isDesktop ? 729 : isTablet ? 400 : isMobile ? 278 : 550}
                height={18}
                borderRadius={8}
              />
            </FlexibleDiv>

            <FlexibleDiv bottom={8}>
              <Skeleton
                width={isDesktop ? 729 : isTablet ? 400 : isMobile ? 278 : 550}
                height={18}
                borderRadius={8}
              />
            </FlexibleDiv>

            <Skeleton
              width={isDesktop ? 436 : isTablet ? 320 : isMobile ? 166 : 360}
              height={18}
              borderRadius={8}
            />
          </FlexibleDiv>
        </Col>
        {isDesktop || isTablet ? (
          <FlexibleDiv top={-20}>
            <Skeleton width={1} height={283} borderRadius={8} />
          </FlexibleDiv>
        ) : null}
      </Row>
    </SummarySkeleton>
  );
};

const DetailOpportunitySkeleton = () => {
  const { isDesktop, isTablet } = useDevice();

  return (
    <OpportunitySkeleton>
      {isDesktop || isTablet ? (
        <FlexibleDiv bottom={38}>
          <Skeleton width={226} height={24} borderRadius={8} />
        </FlexibleDiv>
      ) : null}
      <OpportunitySkeletonContent>
        {[1, 2, 3, 4].map((item) => (
          <FlexibleDiv key={item}>
            <Skeleton
              height={isDesktop || isTablet ? 152 : 139}
              borderRadius={8}
            />
          </FlexibleDiv>
        ))}
      </OpportunitySkeletonContent>
    </OpportunitySkeleton>
  );
};

const DetailAmenitySkeleton = () => {
  const { isDesktop, isTablet } = useDevice();
  return (
    <AmenitySkeleton>
      {isDesktop || isTablet ? (
        <FlexibleDiv bottom={38}>
          <Skeleton width={226} height={24} borderRadius={8} />
        </FlexibleDiv>
      ) : null}
      <AmenitySkeletonContent>
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <FlexibleDiv key={item}>
            <Skeleton
              height={isDesktop || isTablet ? 119 : 139}
              borderRadius={8}
            />
          </FlexibleDiv>
        ))}
      </AmenitySkeletonContent>
    </AmenitySkeleton>
  );
};

const TourDetailSkeleton = () => {
  return (
    <SkeletonWrapper>
      <TrinityImageViewSkeleton />
      <SkeletonContentWrapper>
        <DetailSummarySkeleton />
        <FlexibleDiv bottom={20}>
          <DetailOpportunitySkeleton />
        </FlexibleDiv>
        <DetailAmenitySkeleton />
      </SkeletonContentWrapper>
    </SkeletonWrapper>
  );
};

export default TourDetailSkeleton;
